export default "__VITE_ASSET__ChLB3GWC__"